import React from 'react';
import { Container, Row, Col, Nav, NavItem } from 'reactstrap';
import { NavLink, Link } from 'react-router-dom';
import { useTranslator } from '@front-activerse/common-components';
import { useAppContext } from '@front-activerse/common-components';
import LanguageChange from './LanguageChange';

const Footer = () => {
  const { t, language } = useTranslator();
  const year = new Date().getFullYear();

  const {
    images: { logo, activerse },
    navigation: { footerNavigation },
  } = useAppContext();

  return (
    <footer>
      <Container>
        <Row>
          <Col md="6" className="text-center text-md-start">
            <Link
              to={String(import.meta.env.VITE_LANDING_PAGE_URL) || '/'}
              className="footer-brand"
            >
              <img src={logo} alt={t('app.default.navbarTitle')} className="img-fluid" />
            </Link>
          </Col>

          <Col xs={{ size: 12, order: 1 }} md={{ size: 6, order: 2 }} className="mt-4 mt-md-0">
            <Nav vertical className="align-items-center align-items-md-end">
              {footerNavigation.map(
                (item: { path?: string; translationKey: string; externalPath?: any }) => {
                  if (item.externalPath) {
                    if (typeof item.externalPath === 'object') {
                      return (
                        <a
                          href={item.externalPath[language]}
                          className="nav-link"
                          key={item.translationKey}
                        >
                          {t(item.translationKey)}
                        </a>
                      );
                    }
                    return (
                      <a href={item.externalPath} className="nav-link" key={item.translationKey}>
                        {t(item.translationKey)}
                      </a>
                    );
                  }
                  return (
                    <NavItem key={item.translationKey}>
                      <NavLink to={item.path || '#'} className="nav-link">
                        {t(item.translationKey)}
                      </NavLink>
                    </NavItem>
                  );
                }
              )}
            </Nav>
            <div className="text-center text-md-end">
              <LanguageChange displayLangName={true} />
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md="6" className="text-center text-md-start">
            <p className="description">
              proudly created by{' '}
              <a href="https://activerse.app/">
                <img src={activerse} className="ms-2" alt="activerse.app" />
              </a>
            </p>
          </Col>
          <Col md="6">
            <p className="description text-center text-md-end">
              Copyright ©2021-{year} activerse.app
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
